// Hace que la galería de imágenes del producto cambie sola cada pocos
// segundos EN ESCRITORIO (donde las fotos van agrupadas con miniaturas,
// no apiladas hacia abajo). En móvil no se activa — ahí ya se navega con
// swipe. Se pausa mientras el visitante pasa el mouse encima o interactúa,
// y no corre si el visitante pidió menos movimiento en su sistema.
//
// IMPORTANTE: el contenedor de la galería (GalleryViewer) mezcla varios
// tipos de elementos con "data-media-id" (las diapositivas reales, pero
// también botones ocultos usados solo para abrir el zoom). Por eso este
// script NUNCA reconstruye el orden desde ahí — usa las miniaturas
// (GalleryThumbnails) como única fuente de verdad, que es exactamente lo
// mismo que usa el propio componente nativo de Dawn para saber cuál está
// activa (atributo aria-current).
(function () {
  var ESCRITORIO = window.matchMedia('(min-width: 750px)');
  var MENOS_MOVIMIENTO = window.matchMedia('(prefers-reduced-motion: reduce)');
  var INTERVALO_MS = 4500;

  function iniciar(galeria) {
    var miniaturas = galeria.querySelector('[id^="GalleryThumbnails"]');
    if (!miniaturas) return;

    var pausado = false;
    var temporizador = null;

    // El propio componente nativo de Dawn, dentro de setActiveMedia(), trae
    // de vuelta el scroll de la página hacia la galería si esta ya no está
    // a la vista (pensado para cuando el comprador hace clic en una
    // miniatura). Si el auto-avance llamara a setActiveMedia() mientras el
    // comprador ya bajó a ver el resto de la página, ese mismo código lo
    // regresaría solo hacia arriba cada pocos segundos. Por eso el
    // auto-avance solo actúa mientras la galería sigue visible en pantalla.
    function galeriaVisible() {
      var rect = galeria.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function avanzar() {
      if (pausado || !ESCRITORIO.matches || !galeriaVisible()) return;

      var lista = Array.prototype.slice.call(miniaturas.querySelectorAll('[data-target]'));
      if (lista.length < 2) return;

      var botonActivo = miniaturas.querySelector('button[aria-current="true"]');
      var itemActivo = botonActivo ? botonActivo.closest('[data-target]') : null;
      var posActual = itemActivo ? lista.indexOf(itemActivo) : -1;
      var siguiente = lista[(posActual + 1) % lista.length];
      if (!siguiente) return;

      if (typeof galeria.setActiveMedia === 'function') {
        galeria.setActiveMedia(siguiente.dataset.target, false);
      }
    }

    function detener() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    function comenzar() {
      detener();
      if (!ESCRITORIO.matches || MENOS_MOVIMIENTO.matches) return;
      if (miniaturas.querySelectorAll('[data-target]').length < 2) return;
      temporizador = setInterval(avanzar, INTERVALO_MS);
    }

    galeria.addEventListener('mouseenter', function () { pausado = true; });
    galeria.addEventListener('mouseleave', function () { pausado = false; });
    galeria.addEventListener('focusin', function () { pausado = true; });
    galeria.addEventListener('focusout', function () { pausado = false; });

    ESCRITORIO.addEventListener('change', comenzar);
    comenzar();
  }

  document.querySelectorAll('media-gallery').forEach(iniciar);
})();
